export default __webpack_public_path__ + "static/media/G0007.a889c004.png";